/**
 * Opens a URL in a new tab without navigating away from the current page.
 *
 * `rel="noopener noreferrer"` keeps the opened page from reaching back through
 * `window.opener`.
 */
export function openInNewTab(url: string) {
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.target = "_blank";
  anchor.rel = "noopener noreferrer";
  anchor.click();
}
